"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebFFmpeg = void 0;
const Comlink = __importStar(require("comlink"));
const ffmpeg_1 = __importDefault(require("./ffmpeg"));
const progress_1 = require("./progress");
__exportStar(require("./fetchFile"), exports);
__exportStar(require("./progress"), exports);
class WebFFmpeg {
    constructor(options = {}) {
        if (options.pathPrefix && options.pathPrefix !== '' && !options.pathPrefix.endsWith('/')) {
            options.pathPrefix += '/';
        }
        this.options = options;
    }
    setProgress(progress) {
        this.progress = progress;
    }
    async run(args, files = []) {
        let res = [];
        const preRun = (module) => {
            function outFix(cb) {
                let buf = [];
                const push = () => cb(module.UTF8ArrayToString(buf, 0));
                return function (char, flush) {
                    if (flush && buf.length)
                        return push();
                    if (char === 10 || char === 13) {
                        push();
                        buf = [];
                    }
                    else if (char !== 0)
                        buf.push(char);
                };
            }
            module.stdout = outFix(module.print);
            module.stderr = outFix(module.printErr);
            module.FS.mkdir("/root");
            module.FS.chdir("/root");
            files.forEach(file => {
                const fd = module.FS.open(file.name, "w+");
                const data = new Uint8Array(file.data);
                module.FS.write(fd, data, 0, data.length);
                module.FS.close(fd);
            });
        };
        const postRun = (module) => {
            const con = module.FS.lookupPath('/root', null).node.contents;
            const out = Object.values(con);
            res = out.filter((x) => !files.find(f => f.name === x.name))
                .map(x => {
                return { name: x.name, data: module.FS.readFile(x.name) };
            });
        };
        const log = (message) => {
            if (!this.options.log) {
                return;
            }
            console.log(message);
        };
        const parseMessage = (message) => {
            log(message);
            (0, progress_1.parseProgress)(message, this.progress);
        };
        // log command args
        log(args);
        let isError = false;
        let ignoreDigMessage = false;
        const errorMessages = [];
        await (0, ffmpeg_1.default)({
            arguments: args,
            stdin: () => {
                console.debug;
            },
            print: (message) => {
                parseMessage(message);
            },
            printErr: (message) => {
                parseMessage(message);
                if (message.startsWith('ffmpeg version')) {
                    ignoreDigMessage = true;
                }
                if (message.startsWith('  libswresample')) {
                    ignoreDigMessage = false;
                    return;
                }
                if (ignoreDigMessage) {
                    return;
                }
                errorMessages.push(message);
            },
            preRun: preRun,
            postRun: postRun,
            onExit: (code) => {
                if (code !== 0) {
                    isError = true;
                }
            },
            locateFile: this.options.pathPrefix ? (path, scriptDirectory) => this.options.pathPrefix + path : undefined
        });
        if (isError) {
            throw new Error(errorMessages.join('\n'));
        }
        return res;
    }
    async codecs() {
        await this.run(['-codecs']);
    }
}
exports.WebFFmpeg = WebFFmpeg;
Comlink.expose(WebFFmpeg);
